const Reflux = require('@muzzylane/reflux');

const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const ServerRequest = require('./request');

const ChannelActions = Reflux.createActions({
    getAllChannels: { children: ['completed', 'failed' ] },
    createFolder: { children: ['completed', 'failed'] },
    createSubfolder: { children: ['completed', 'failed'] },
    deleteFolder: { children: ['completed', 'failed'] },
    renameFolder: { children: ['completed', 'failed'] },
    adminGetChatbotUsage: { children: ['completed', 'failed'] },
});

ChannelActions.getAllChannels.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/channels_v2', 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ChannelActions.createFolder.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/channels/${params.channelId}/folders`, 'PUT', JSON.stringify({
            name: params.name,
            content_type: params.contentType || null,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ChannelActions.createSubfolder.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/folders/${params.folderId}/folders`, 'PUT', JSON.stringify({
            name: params.name,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ChannelActions.deleteFolder.listen(function(actionId, params) {
    if (!params.folderId || !params.channelId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/folders/${params.folderId}`, 'DELETE')
        .then(res => this.completed(actionId, params.folderId, params.channelId, res))
        .catch(err => this.failed(actionId, params.folderId, params.channelId, err));
});

ChannelActions.renameFolder.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/folders/${params.folderId}`, 'PATCH', JSON.stringify({
            name: params.name,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

// ABANDONED
// ChannelActions.transferFolder.listen(function(actionId, params) {
//     const self = this;
//     let toFolder;
//     if (params.toFolder) {
//         toFolder = params.toFolder;
//     }
//     else if (params.toChannel) {
//         toFolder = 'root';
//     }
//     else {
//         this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
//     }

//     ServerRequest.makeRequest(`/authoring/folders/${params.folderId}`, 'PATCH', JSON.stringify({
//             toFolder: toFolder,
//         }))
//         .then(res => self.completed(actionId, res))
//         .catch(err => self.failed(actionId, err));
// });


ChannelActions.adminGetChatbotUsage.listen(function(actionId,channelId) {
    ServerRequest.makeRequest(`/authoring/channel_chatbot_usage/${channelId}`, 'GET')
    .then(res => this.completed(actionId, channelId, res))
    .catch(err => this.failed(actionId, channelId, err));
});


module.exports = ChannelActions;